<template>
      <!--van-button v-if="userData.userDataHandVo.handChecked" color="linear-gradient(to right, #f67f34, #d55809)"  round
        block to="addUserData">新增评测任务</van-button>
        <van-notice-bar v-if="userData.userDataHandVo.handChecked"
    wrapable :scrollable="false" 
                left-icon="volume-o">
              <p class="text2Indentation">新增数据的展示有延迟，延迟在2分钟以内</p>
  </van-notice-bar-->
<van-tabs v-model:active="active" sticky >
  <van-tab title="血压数据" name="a">
   <br/>
  <van-list>
    <van-cell-group inset v-for="(bloodPressure, id) in bloodPressureList.bloodPressure" :key="id" :title="bloodPressure.id">
        <van-field v-model="bpCheckDate"  label="记录时间" :placeholder="bloodPressure.createTime" label-align="left" readonly/>
        <van-field v-model="diastolicBloodPressure" error label="舒张压" :placeholder="bloodPressure.diastolicBloodPressure" label-align="right" readonly/>
        <van-field v-model="systolicBloodPressure" error label="收缩压" :placeholder="bloodPressure.systolicBloodPressure" label-align="right" readonly/>
    </van-cell-group>
  </van-list>

  </van-tab>
  <van-tab title="血脂数据" name="b">
    <van-list>
     <van-cell-group inset v-for="(bloodLipid, id) in bloodLipidList.bloodLipid" :key="id" :title="bloodLipid.id">
        <van-field v-model="ldCheckDate" label="记录时间" :placeholder="bloodLipid.createTime" label-align="left" readonly/>
        <van-field v-model="tc"  label="TC" error :placeholder="bloodLipid.lipidTc" label-align="right" readonly/>
        <van-field v-model="tg" label="TG" error :placeholder="bloodLipid.lipidTg" label-align="right" readonly/>
        <van-field v-model="tg" label="HDL-C"  error :placeholder="bloodLipid.lipidHdlC" label-align="right" readonly/>
        <van-field v-model="tg" label="LDL-C" error :placeholder="bloodLipid.lipidLipidLdl" label-align="right" readonly/>
     </van-cell-group>
  </van-list>
  </van-tab>
  <!--van-tab title="心率数据" name="c">
  <van-list>
    <van-cell-group inset v-for="(heartRate, id) in heartRateList.heartRate" :key="id" :title="heartRate.id">
        <van-field v-model="hrCheckDate" label="记录时间" :placeholder="heartRate.createTime" label-align="left" readonly/>
        <van-field v-model="restingHeartRate" error label="心率" :placeholder="heartRate.restingHeartRate" label-align="right" readonly/>
      </van-cell-group>
  </van-list>
  </van-tab>
  <van-tab title="血氧数据" name="d">
    <van-list>
    <van-cell-group inset v-for="(bloodOxygen, id) in bloodOxygenList.bloodOxygen" :key="id" :title="bloodOxygen.id">
        <van-field v-model="boCheckDate" label="记录时间" :placeholder="bloodOxygen.createTime" label-align="left" readonly/>
        <van-field v-model="bloodOxygenSaturation" error label="血氧" :placeholder="bloodOxygen.bloodOxygenSaturation" label-align="right" readonly/>
      </van-cell-group>
  </van-list>
  </van-tab-->
  <van-tab title="钙化积分数据" name="e">
    <van-list>
    <van-cell-group inset v-for="(cacs, id) in bloodCacsList.cacs" :key="id" :title="cacs.id">
        <van-field v-model="cacsCheckDate" label="记录时间" :placeholder="cacs.createTime" label-align="left" readonly/>
        <van-field v-model="bloodCacs"  label="钙化积分" error :placeholder="cacs.bloodCacs" label-align="right" readonly/>
      </van-cell-group>
  </van-list>
  </van-tab>
</van-tabs>
</template>
<script>
import { ref,reactive,onMounted} from 'vue';
import { postBloodPressureData,postBloodCacsData,postBloodLipidData } from '../../api/bloodData'
import { getUserBloodDataById} from '../../api/bloodData'
import { useRouter } from "vue-router";
import { postUserLog } from "../../api/userlog";
export default {
  setup() {
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const activeName = ref('a');
    const router = useRouter();
    const ulog = reactive({
      UserLog: {
        path: "",
      },
    });
    const bloodPressureList = reactive({
          bloodPressure: {
                id: '',
                systolicBloodPressure: '',
                diastolicBloodPressure: '',
                checkDate: '',
                createTime: '',
                status: '',
            }
        });
    const bloodCacsList = reactive({
        cacs: {
                id: '',
                bloodCacs: '',
                checkDate: '',
                createTime: '',
                status: '',
            }
        });
    const bloodOxygenList = reactive({
        bloodOxygen: {
                id: '',
                bloodOxygenSaturation: '',
                checkDate: '',
                createTime: '',
                status: '',
            }
        });
    const heartRateList = reactive({
        heartRate: {
                id: '',
                restingHeartRate: '',
                checkDate: '',
                createTime: '',
                status: '',
            }
        });
    const bloodLipidList = reactive({
          bloodLipid: {
                id: '',
                lipidTc: '',
                lipidTg: '',
                lipidHdlC: '',
                lipidLipidLdl: '',
                checkDate: '',
                createTime: '',
                status: '',
            }
        });
    const userData = reactive({
      userDataHandVo: {
        systolicBloodPressure: "",
        diastolicBloodPressure: "",
        pressureTime: "",
        tc: "",
        tg: "",
        hdlC: "",
        ldlC:"",
        lipidTime:"",
        handChecked:"",
      },
    });
   // const onLoad = () => {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
   //   setTimeout(() => {
   //     for (let i = 0; i < 10; i++) {
  //        list.value.push(list.value.length + 1);
   //     }

        // 加载状态结束
   //     loading.value = false;

        // 数据全部加载完成
   //     if (list.value.length >= 20) {
   //       finished.value = true;
    //    }
   //   }, 1000);
   // };
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      postBloodPressureData().then((res1) =>{
               bloodPressureList.bloodPressure=res1.data.data;
               console.log(bloodPressureList.bloodPressure);
            })
      postBloodCacsData().then((res2) =>{
            bloodCacsList.cacs=res2.data.data;
               console.log(bloodCacsList.cacs);
            })
      //postBloodOxygenData().then((res3) =>{
      //      bloodOxygenList.bloodOxygen=res3.data.data;
      //         console.log(bloodOxygenList.bloodOxygen);
      //      })
      //postHeartRateData().then((res4) =>{
      //      heartRateList.heartRate=res4.data.data;
      //         console.log(heartRateList.heartRate);
      //      })
      postBloodLipidData().then((res5) =>{
            bloodLipidList.bloodLipid=res5.data.data;
               console.log(bloodLipidList.bloodLipid);
            })
      getUserBloodDataById().then((res) =>{
               userData.userDataHandVo=res.data.data;
               console.log(userData.userDataHandVo);
        })
    });
    return { 
      list,
     // onLoad,
      bloodPressureList,
      bloodCacsList,
      bloodOxygenList,
      heartRateList,
      bloodLipidList,
      loading,
      finished,
      activeName,
      userData,
    };
  },
};
</script>
<style lang="less" scoped>
</style>